module.exports = __webpack_public_path__ + "static/media/bars-white.93b692af.svg";